var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 6.92217C19.1368 7.21748 19.268 7.60116 19.268 7.99897C19.268 8.39678 19.1368 8.78045 18.9 9.07577C17.4 10.8919 13.9856 14.4276 9.99993 14.4276C6.01422 14.4276 2.59993 10.8919 1.09993 9.07577C0.863014 8.78045 0.731873 8.39678 0.731873 7.99897C0.731873 7.60116 0.863014 7.21748 1.09993 6.92217C2.59993 5.10607 6.01422 1.57031 9.99993 1.57031C13.9856 1.57031 17.4 5.10607 18.9 6.92217Z",
    stroke: "#3A3737",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 10.856C11.5779 10.856 12.8571 9.57684 12.8571 7.99888C12.8571 6.42093 11.5779 5.14174 9.99997 5.14174C8.42202 5.14174 7.14283 6.42093 7.14283 7.99888C7.14283 9.57684 8.42202 10.856 9.99997 10.856Z",
    stroke: "#3A3737",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewList);
export default __webpack_public_path__ + "static/media/previewList.8ce9045eb5de3dc7d3a455d3efb6591a.svg";
export { ForwardRef as ReactComponent };